export const dateToUTCDate = (d: Date | string) => {
  const date = new Date(d)
  return Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())
}
